import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { StoreProvider } from "./src/context/store-context"
import "./src/styles/reset.css"
import "./src/styles/variables.css"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => (
  <StoreProvider><AnimatePresence mode='wait'>{element}</AnimatePresence></StoreProvider>
)